import { MeetingTypeResourceTypeMappings } from '@aa/nest/resource';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { FormlyFieldConfig } from '@ngx-formly/core';
import {
  BaseFormModalComponent,
  baseFormModalImports,
  FormModalData,
} from '../../components/base-form-modal/base-form-modal.component';
import { CoreAppState } from '../../state/core-app.state';
import { meetingTypeActions } from '../../state/meeting-type/meeting-type.actions';

export type MeetingTypeFormModel = Partial<
  MeetingTypeResourceTypeMappings['createDTO']
>;
export type MeetingTypeFormModalData = FormModalData<MeetingTypeFormModel>;

@Component({
  selector: 'aa-meeting-type-form-modal',
  standalone: true,
  imports: [...baseFormModalImports],
  templateUrl:
    '../../components/base-form-modal/base-form-modal.component.html',
  styleUrl: '../../components/base-form-modal/base-form-modal.component.scss',
})
export class MeetingTypeFormModalComponent extends BaseFormModalComponent<
  MeetingTypeFormModel,
  MeetingTypeFormModalData
> {
  title = 'Meeting Type';
  fields: FormlyFieldConfig[] = [
    {
      key: 'label',
      type: 'input',
      props: {
        label: 'Label',
        type: 'text',
        required: true,
      },
    },
    {
      key: 'description',
      type: 'input',
      props: {
        label: 'Description',
        type: 'text',
        required: true,
      },
    },
    {
      key: 'price',
      type: 'input',
      props: {
        label: 'Price (USD)',
        type: 'number',
        required: false,
      },
    },
    {
      key: 'durationInMinutes',
      type: 'input',
      props: {
        label: 'Duration (Minutes)',
        type: 'number',
        required: false,
      },
    },
  ];

  createAction = meetingTypeActions.createItem;
  updateAction = meetingTypeActions.updateItem;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    protected override readonly data: MeetingTypeFormModalData,
    protected override readonly dialogRef: MatDialogRef<MeetingTypeFormModalComponent>,
    protected override readonly store: Store<CoreAppState>,
  ) {
    super(data, dialogRef, store);
  }
}
